export const TwitterIcon = () => (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="Img">
            <path
                id="Vector"
                d="M11.3412 3.25H13.1229L9.23137 7.69736L13.8094 13.75H10.2257L7.41683 10.08L4.2067 13.75H2.42244L6.58402 8.99219L2.19531 3.25H5.86981L8.40612 6.60445L11.3412 3.25ZM10.7153 12.6849H11.7021L5.33226 4.25962H4.27231L10.7153 12.6849Z"
                fill="#6B7682"
            />
        </g>
    </svg>
);
